import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import GreenButton from "../cinema-draft-button/cinema-draft-button.component";
import Dropdownn from "../dropdown/dropdown_";
import styles from "./actionbar.module.scss";
import axios from "axios";
import trximage from "../../public/TRX per CD3D - Icon.svg";
import contract_img from "../../public/TRX in contract - Icon.svg";
import Contract_obj from "../../getTronweb";
import { connect } from "react-redux";
import * as actions from "../../actions";
import metacoinConfig from "../../metacoin-config.js";
import { Tooltip } from "antd";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import IconButton from "@material-ui/core/IconButton";
import LaunchIcon from "@material-ui/icons/Launch";
import AnimatedButton from "../AnimatedButton";
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
const Actionbar = ({ updated, history, flag, page, theme, ...props }) => {
  const [tokens, setTokens] = useState();
  const [trxPerToken, setTrxPerToken] = useState();
  const [usd, setUsd] = useState();
  const [tron, setTron] = useState();
  const [contractBalance, setContractBalance] = useState();

  const fetchData = async () => {
    // console.log("TTTTTTTTTTronm", Contract_obj);

    window.tronWeb && await Contract_obj.init(window.tronWeb.fullNode.host == "https://api.shasta.trongrid.io"
    ? "shasta"
    : "mainnet");
    // console.log("TTTTTTTTTTron", Contract_obj);
    (await Contract_obj.tronWebProvider) &&
      Contract_obj.tronWebProvider.trx
        .getBalance(Contract_obj.contractAddress)
        .then(result => {
          setContractBalance(result);
        });
    Contract_obj.contract_instace &&
      (await Contract_obj.contract_instace
        .myTokens()
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
          callValue: Contract_obj.callValue || 0
        })
        .then(function (res) {
          if (res) {
           
            setTokens((parseInt(res.toString()) / 1e6).toFixed(3));
            if (parseInt(res.toString()) == 0) {
              setTron("0");
            } else {
              Contract_obj.contract_instace
                .tokensToTron_(res.toString())
                .call({
                  from: Contract_obj.accounts[0],
                  feeLimit: Contract_obj.feeLimit
                })
                .then(function (tron) {
                  setTron(tron.toString());
                });
            }
          }
        }));
        var obj = setInterval(async () => {
          if (
            window.tronWeb &&
            Contract_obj.contract_instace 
          ) {
            await Contract_obj.contract_instace
            .buyPrice()
            .call({
              from: Contract_obj.accounts[0],
              feeLimit: Contract_obj.feeLimit,
            })
            .then(function (res) {
              if (res) {
                console.log(res.toString(), "Price buy" );
                setTrxPerToken((parseInt(res.toString()) / 1e6).toFixed(3));
                clearInterval(obj);


              }
            })
          }
        
        }, 2);
        

  };
  useEffect(() => {
    if (tokens) {
      Contract_obj.contract_instace
        .tokensToTron_(parseInt(tokens) * 1e6)
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit
        })
        .then(function (tron) {
          setTron(tron.toString());
        });
    } else if (tokens == 0) {
      setTron("0");
    }
  }, [tokens]);
  useEffect(() => {
    fetchData();

    var obj = setInterval(async () => {
      if (
        window.tronWeb &&
        window.tronWeb.defaultAddress.base58 &&
        window.tronWeb.fullNode.host == metacoinConfig.fullHost
      ) {
        clearInterval(obj);
        fetchData();
      }
    }, 2);
    window.addEventListener("message", function (e) {
      if (e.data.message && e.data.message.action == "setNode") {
        // console.log("setNode event", e.data.message);

        if (
          window.tronWeb &&
          window.tronWeb.fullNode.host == metacoinConfig.fullHost
        ) {
          fetchData();
        }
      }
    });
  }, []);
  useEffect(() => {
    fetchData();
  }, [updated, theme]);
  return (
    <>
     
      <div
        className={styles.actionbar_div}
        style={{ display: flag == 0 && "none" }}
      >
        <span className={styles.action_item}>My Holdings</span>
        <div className={styles.action_stat}>
          <img
            src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1609932216/cd3d/Group_4092_1_kzlrrz.png"
            width="24"
            height="24"
          />
          <span className={styles.stat}>{tokens && tokens} CETO</span>
        </div>
        {/* <CompareArrowsIcon></CompareArrowsIcon> */}
        <span >~</span>
        <div className={styles.action_stat}>
          <img
            src="https://res.cloudinary.com/dgdjabqwr/image/upload/v1610713939/cd3d/Tron_-_Icon_1_pnwjmc.png"
            width="16"
            height="auto"
          />

          <Dropdownn
            heading="tokens"
            className={styles.stat}
            value={[
              `${tron ? (tron / 1e6).toFixed(3) : ""} TRX`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.USD).toFixed(2)
                  : ""
              } USD`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.CHF).toFixed(2)
                  : ""
              } CHF`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.EUR).toFixed(2)
                  : ""
              } EUR`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.GIP).toFixed(2)
                  : ""
              } GIP`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.KWD).toFixed(2)
                  : ""
              } KWD`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.GBP).toFixed(2)
                  : ""
              } GBP`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.JOD).toFixed(2)
                  : ""
              } JOD`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.OMR).toFixed(2)
                  : ""
              } OMR`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.BHD).toFixed(2)
                  : ""
              } BHD`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.CAD).toFixed(2)
                  : ""
              } CAD`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.INR).toFixed(2)
                  : ""
              } INR`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.JPY).toFixed(2)
                  : ""
              } JPY`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.HKD).toFixed(2)
                  : ""
              } HKD`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.PAB).toFixed(2)
                  : ""
              } PAB`,
              `${
                tron
                  ? ((tron / 1e6) * props.utils.currencies.AED).toFixed(2)
                  : ""
              } AED`
            ]}
            footer={[
              `${tron ? tron : ""} TRX`,
              `${
                tron ? (tron * props.utils.currencies.USD).toFixed(2) : ""
              } USD`
            ]}
          />
          <Tooltip title="TRX value of your CETO">
            <IconButton color="primary" style={{ padding: 0 }}>
              <HelpOutlineIcon
                style={{
                  color: "#1FD0FF",
                  width: "18px",
                  height: "18px",
                  margin: "0 10px"
                }}
              />
            </IconButton>
          </Tooltip>
        </div>

        <GreenButton
          style={{ background: "#002E8C", color: "#ffffff" }}
          className={styles.lt}
          onClick={() => history.replace({ pathname: "/buy" })}
          actionbar={true}
        >
          BUY CETO
        </GreenButton>

        <div className={styles.with}>
          <GreenButton
            style={{
              background: "white",
              color: "#009EE4",
              border: "1px solid #009EE4",
              boxShadow: "none"
            }}
            className={styles.l}
            onClick={() => history.replace({ pathname: "/buy" })}
          >
            Reinvest
          </GreenButton>{" "}
        </div>
        <GreenButton
          style={{ background: "#691AAA" }}
          className={styles.lt}
          onClick={() => history.replace({ pathname: "/sell" })}
          actionbar={true}
        >
          SELL CETO
        </GreenButton>

        <a
          className={`${styles.link}  ${styles.with}`}
          onClick={() => history.replace({ pathname: "/withdraw" })}
        >
          withdraw
        </a>
        <div className={`${styles.action_stat} ${styles.l}`}>
          <img src={contract_img} width="24" height="24" />
          <span className={styles.stat}>
            {contractBalance && (contractBalance / 1e6).toFixed(3)} TRX in
            contract
          </span>
        </div>
        {page == 1 ? (
          <a
            href="https://www.youtube.com/channel/UCNRN6hw26z6TGWiZpAk5XXQ"
            target="_blank"
            className={`${styles.visit} ${styles.l}`}
          >
            Youtube <LaunchIcon style={{ margin: "-5px 0" }}></LaunchIcon>
          </a>
        ) : (
          <div className={`${styles.action_stat} ${styles.l}`}>
            <img src={trximage} width="24" height="24" />
            <span className={styles.stat}>{trxPerToken} TRX/CETO</span>
            <Tooltip title={`Buy price of 1 CETO`}>
            <IconButton color="primary" style={{ padding: 0, marginLeft:"10px" }}>
              <HelpOutlineIcon
                style={{
                  color: "#1FD0FF",
                  width: "18px",
                  height: "18px",
                  margin: "0 10px",
                }}
              />
            </IconButton>
          </Tooltip>
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    utils: state.utils
  };
};

export default connect(mapStateToProps, actions)(Actionbar);
